import type {
  LeadItem,
  GetLeadItemsRequest,
  ApiResponse,
} from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type LeadItemStore = StoreEntity<
  LeadItem,
  'itemId',
  GetLeadItemsRequest
>;

export const useLeadItemStore = apiStoreFactory<
  LeadItemStore['entity'],
  LeadItemStore['id'],
  LeadItemStore['filter'],
  LeadItemStore['createInput'],
  LeadItemStore['updateInput']
>(
  STORE.LEAD_ITEM,
  { entityIdKey: 'itemId' },
  {
    readAll: async (filter, { dialbunnyApi, pubSub }, signal) => {
      const result = await dialbunnyApi.getLeadItemsRaw(filter, { signal });
      const value = result.value();
      const items = await value;

      for (const item of items) {
        pubSub.cacheUpdate(item.lead.key, item.lead);
        pubSub.cacheUpdate(item.item.key, item.item);
      }

      // to prevent error on double reading fetch response
      return {
        ...result,
        value: () => value,
      } as ApiResponse<LeadItem[]>;
    },
  },
);
